
import Vue from 'vue';

export default Vue.extend({
  name: 'BaseInputCheckbox',
  props: {
    classes: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    checked: {
      type: Boolean,
    },
  },
  methods: {
    callback: function(e) {
      this.$emit('change', e);
    },
  },
});
